import { FluidObject } from "gatsby-image";
import { pp } from "./pretty-print";

export default function getFluidImageOrThrow(
  imageName: string,
  data: any
): FluidObject {
  if (data.staticImagesJson?.images?.[imageName]?.fluid == null) {
    throw Error(
      `data.staticImagesJson?.images?.${imageName}?.fluid is null: ` +
        `${pp({ data })}`
    );
  }
  return data.staticImagesJson.images[imageName].fluid;
}
